module.exports = __webpack_public_path__ + "static/media/Amazon-Clone.7c74bf44.png";